<div class="d-flex flex-nowrap overflow-x-auto gap-3 mb-2 pb-1">
  @for (item of summary(); track item.depositTypeId) {
    <div class="card border-0 shadow-sm rounded-4 bg-light" style="flex: 1 1 0; min-width: 200px">
      <div class="card-body p-3 d-flex flex-column gap-2">
        <h3 class="fs-16 fw-600 mb-0 text-truncate">{{ item.name }}</h3>
        <div class="d-flex flex-column gap-2">
          <div class="d-flex justify-content-between align-items-center gap-2 bg-white rounded-3 px-2 py-2">
            <span class="fs-12 fw-500 text-dark">Scheduled:</span>
            <span class="fs-14 fw-600 text-dark">{{ item.scheduled | currencyFormat }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center gap-2 bg-white rounded-3 px-2 py-2">
            <span class="fs-12 fw-500 text-dark">Paid:</span>
            <span class="fs-14 fw-600 text-success">{{ item.received | currencyFormat }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center gap-2 bg-white rounded-3 px-2 py-2">
            <span class="fs-12 fw-500 text-dark">Due:</span>
            <span class="fs-14 fw-600 text-danger">{{ item.due | currencyFormat }}</span>
          </div>
        </div>
      </div>
    </div>
  }
</div>
